export class CustomerGroupChangeRequestDataObject {
	/**
	 * @param {string} groupId - DB ID for the customer group.
	 * @param {CustomerGroupRequestType} changeType - Type of the change (add or remove).
	 * @param {string} fileName - Name of the import file if import was done using an uploaded file.
	 * @param {Date} startDate - Date and time when import started.
	 */
	constructor(groupId, changeType, fileName, startDate) {
		this.groupId = groupId;
		this.changeType = changeType;
		this.startDate = startDate;
		this.fileName = fileName;
	}
}